<!-- 联系我们 -->
 <template>
  <div>
    <div class="right-item-content">
      <div>公司名称:河北领点枫科技有限公司</div>
      <div style="margin-top: 20px">
        公司地址:河北省石家庄市新华区鹿诚商务中心6号楼1304室
      </div>
    </div>
    <div class="right-item-content">
      <div>客服热线:19272927776</div>
      <div style="margin-top: 20px">客服微信:zyf2096xx</div>
      <div style="margin-top: 20px">邮箱:zyf802@qq.com</div>
    </div>
  </div>
</template>

 <script>
export default {};
</script>

 <style lang="scss" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: #f8f8fa;
  border-radius: 8px;
}
</style>
